import { useContext } from 'react';
import { sameIssuerCurrencyContext } from './context';

export const useSameIssuerCurrency = () => {
  const currency = useContext(sameIssuerCurrencyContext);
  return currency;
};
